import { mapEntityTypeFromDTO } from '@/modules/common/mappers/entity-type.mapper';
import { IntegrationConflictsSummaryResponse } from '@/modules/common/types/dto/response/integration-conflicts-response';
import { IntegrationConflictsSummary } from '@/modules/common/types/integration-conflicts';

export const mapIntegrationConflictsSummaryFromDTO = (
  response: IntegrationConflictsSummaryResponse
): IntegrationConflictsSummary => ({
  hasConflicts: response.hasConflicts,
  entityTypes: response.entityTypes.map(mapEntityTypeFromDTO),
  administrators: response.administrators.map(({ name, email }) => ({ name, email })),
});
